import { useEffect, useState } from "react";
import { Link, useNavigate, useParams } from "react-router-dom";
import { useTranslation } from "react-i18next";
import { comnEnvs, comnUtils } from "@/comn/utils";
import { Page, Group, Layout, Button, ExcelUpload } from "@/comn/components";
import {
    useForm,
    useToast,
    useFetch,
    useModal,
    useAuth,
    useStore,
    useGrid,
    usePopup,
    useResource,
    useExcel,
    usePage,
} from "@/comn/hooks";
import {
    COMN_BASE,
    COMN_URLS,
    COMN_APIS,
    SF_APP_DTL_PTY,
} from "@/tz/go/egaz/osci/lpco/comn/services/OsciLpcoComnAppService";
import { SF_APP_DTL_ADD_ITM, SF_APP_RGST_OFCR_ADD_ITM } from "@/tz/go/egaz/osci/lpco/comn/services/OsciLpcoComnAppAddItmService";
import { APP_DTL_ADD_ITM } from "@/tz/go/egaz/osci/lpco/comn/APP_DTL_ADD_ITM";
import { APP_AMD_DTL_ADD_ITM } from "@/tz/go/egaz/osci/lpco/comn/APP_AMD_DTL_ADD_ITM";
import { APP_AMD_RGST_OFCR_ADD_ITM } from "@/tz/go/egaz/osci/lpco/comn/APP_AMD_RGST_OFCR_ADD_ITM";

export const APP_AMD_DTL_GEN = (props: any) => {
    const { pgeUid, menuId } = usePage();
    const { t } = useTranslation(); // Translation Hook !== 언어 변화 Hook ==!
    const navigate = useNavigate(); // Navigate Hook !== 화면 이동 Hook ==!
    const modal = useModal(); // Modal Window Hook !== Modal 창 Hook ==!
    const { pgeStore, setStore } = useStore({ pgeUid: pgeUid }); // Page Store Hook !== 화면 데이터 저장 Hook ==!
    const toast = useToast(); // Toast Message Hook !== Toast 메세지 표시 Hook ==!

    const appTpCd = props.state?.appTpCd;
    const appClsfCd = props.state?.appClsfCd;

    const [visible, setVisible] = useState(false); // User define State !== 사용자 정의 스테이트 ==!
    const [exppnVisible, setExppnVisible] = useState(true); // User define State !== 사용자 정의 스테이트 ==!
    const [imppnVisible, setImppnVisible] = useState(false); // User define State !== 사용자 정의 스테이트 ==!

    const form = {
        appDtlAplc: useForm({
            defaultSchema: SF_APP_DTL_PTY,
        }),
        appDtlExppn: useForm({
            defaultSchema: SF_APP_DTL_PTY,
        }),
        appDtlConsr: useForm({
            defaultSchema: SF_APP_DTL_PTY,
        }),
        appDtlImppn: useForm({
            defaultSchema: SF_APP_DTL_PTY,
        }),
        appDtlCnsl: useForm({
            defaultSchema: SF_APP_DTL_PTY,
        }),
        appDtlAddItm: useForm({
            defaultSchema: SF_APP_DTL_ADD_ITM,
        }),
        appRgstOfcrAddItm: useForm({
            defaultSchema: SF_APP_RGST_OFCR_ADD_ITM,
        }),
    };
    const bfAppInfo = props.bfParam?.appId != null && props.bfParam?.appId !== ""
            ? props.bfParam
            : { ...props.form?.getValues() };
    const bfForm = {
        appDtlAplc: useForm({
            defaultSchema: SF_APP_DTL_PTY,
        }),
        appDtlExppn: useForm({
            defaultSchema: SF_APP_DTL_PTY,
        }),
        appDtlConsr: useForm({
            defaultSchema: SF_APP_DTL_PTY,
        }),
        appDtlImppn: useForm({
            defaultSchema: SF_APP_DTL_PTY,
        }),
        appDtlCnsl: useForm({
            defaultSchema: SF_APP_DTL_PTY,
        }),
        appDtlAddItm: useForm({
            defaultSchema: SF_APP_DTL_ADD_ITM,
        }),
        appRgstOfcrAddItm: useForm({
            defaultSchema: SF_APP_RGST_OFCR_ADD_ITM,
        }),
    };

    useEffect(() => {
        handler.setInit();
    }, []);

    /*
     * Application Parth Detail Event Handler
     * !== 이벤트 핸들러 정의 ==!
     */
    const handler = {
        setInit: async () => {
            // Applicant 정보 초기 설정 !== Applicant information initial settings ==!
            form.appDtlAplc.setSchema("ptyCd", { label: "L_APLC_CD" });
            form.appDtlExppn.setSchema("ptyCd", { label: "L_CO_CD" });
            form.appDtlConsr.setSchema("ptyCd", { label: "L_CO_CD" });
            form.appDtlImppn.setSchema("ptyCd", { label: "L_CO_CD" });
            form.appDtlCnsl.setSchema("ptyCd", { label: "L_CO_CD" });

            bfForm.appDtlAplc.setSchema("ptyCd", { label: "L_APLC_CD" });
            bfForm.appDtlExppn.setSchema("ptyCd", { label: "L_CO_CD" });
            bfForm.appDtlConsr.setSchema("ptyCd", { label: "L_CO_CD" });
            bfForm.appDtlImppn.setSchema("ptyCd", { label: "L_CO_CD" });
            bfForm.appDtlCnsl.setSchema("ptyCd", { label: "L_CO_CD" });

            // 신청서 분류 코드에 따라 입력항목 표시 !== Display input items according to Application Classification Code ==!
            if ((appClsfCd == "X" && appTpCd == "CA") || appClsfCd != "X") {
                setVisible(false);
            }

            if ("MA" != appTpCd) {
                setImppnVisible(true);
            }

            fetch.getAppPtyList.fetch();
        },
    };

    const fetch = {
        // Get Application Party List !== 신청서 당사자 목록 조회 ==!.
        getAppPtyList: useFetch({
            api: () => COMN_APIS.getAppPtyList({ ...props.state }),
            onSuccess: (data) => {
                data.appPtyList.content.map((item: any) => {
                    if ("APP" == item.ptyTpCd) {
                        form.appDtlAplc.setValues(item);
                    } else if ("EXP" == item.ptyTpCd) {
                        if ("MA" == appTpCd) {
                            setExppnVisible(true);
                            setImppnVisible(false);
                        }
                        form.appDtlExppn.setValues(item);
                    } else if ("CSR" == item.ptyTpCd) {
                        form.appDtlConsr.setValues(item);
                    } else if ("IMP" == item.ptyTpCd) {
                        if ("MA" == appTpCd) {
                            setExppnVisible(false);
                            setImppnVisible(true);
                        }
                        form.appDtlImppn.setValues(item);
                    } else if ("CSE" == item.ptyTpCd) {
                        form.appDtlCnsl.setValues(item);
                    }
                });

                fetch.getBeforeAppPtyList.fetch();
            },
            onError: (error) => {},
            showToast: false,
        }),
        // Get Application Party List !== 신청서 당사자 목록 조회 ==!.
        getBeforeAppPtyList: useFetch({
            api: () => COMN_APIS.getAppPtyList({ ...bfAppInfo }),
            onSuccess: (data) => {
                data.appPtyList.content.map((item: any) => {
                    if ("APP" == item.ptyTpCd) {
                        bfForm.appDtlAplc.setValues(item);
                    } else if ("EXP" == item.ptyTpCd) {
                        if ("MA" == appTpCd) {
                            setExppnVisible(true);
                            setImppnVisible(false);
                        }
                        bfForm.appDtlExppn.setValues(item);
                    } else if ("CSR" == item.ptyTpCd) {
                        bfForm.appDtlConsr.setValues(item);
                    } else if ("IMP" == item.ptyTpCd) {
                        if ("MA" == appTpCd) {
                            setExppnVisible(false);
                            setImppnVisible(true);
                        }
                        bfForm.appDtlImppn.setValues(item);
                    } else if ("CSE" == item.ptyTpCd) {
                        bfForm.appDtlCnsl.setValues(item);
                    }
                });

                if (
                    !comnUtils.isEmpty(form.appDtlAplc.getValues()) &&
                    !comnUtils.isEmpty(bfForm.appDtlAplc.getValues())
                ) {
                    Object.entries(form.appDtlAplc.getValues()).forEach((afItem) => {
                        Object.entries(bfForm.appDtlAplc.getValues()).forEach((bfItem) => {
                            if (afItem[0] == bfItem[0]) {
                                if (afItem[1] != bfItem[1]) {
                                    form.appDtlAplc.setSchema(afItem[0], {
                                        edit: true,
                                        borderColor: "warning",
                                        readOnly: true,
                                    });
                                }
                            }
                        });
                    });
                }

                if (
                    !comnUtils.isEmpty(form.appDtlExppn.getValues()) &&
                    !comnUtils.isEmpty(bfForm.appDtlExppn.getValues())
                ) {
                    Object.entries(form.appDtlExppn.getValues()).forEach((afItem) => {
                        Object.entries(bfForm.appDtlExppn.getValues()).forEach((bfItem) => {
                            if (afItem[0] == bfItem[0]) {
                                if (afItem[1] != bfItem[1]) {
                                    form.appDtlExppn.setSchema(afItem[0], {
                                        edit: true,
                                        borderColor: "warning",
                                        readOnly: true,
                                    });
                                }
                            }
                        });
                    });
                }

                if (
                    !comnUtils.isEmpty(form.appDtlImppn.getValues()) &&
                    !comnUtils.isEmpty(bfForm.appDtlImppn.getValues())
                ) {
                    Object.entries(form.appDtlImppn.getValues()).forEach((afItem) => {
                        Object.entries(bfForm.appDtlImppn.getValues()).forEach((bfItem) => {
                            if (afItem[0] == bfItem[0]) {
                                if (afItem[1] != bfItem[1]) {
                                    form.appDtlImppn.setSchema(afItem[0], {
                                        edit: true,
                                        borderColor: "warning",
                                        readOnly: true,
                                    });
                                }
                            }
                        });
                    });
                }
            },
            onError: (error) => {},
            showToast: false,
        }),
    };

    return (
        <>
            <Layout gap={2}>
                {/* General Info Before Modification Start */}
                <Group>
                    <Group.Body>
                        <Layout direction="col">
                            <Layout>
                                <Layout.Left>
                                    <Group.Title title={"T_APLC"} titleSize={1}></Group.Title>
                                </Layout.Left>
                            </Layout>

                            <Group.Section>
                                <Group.Row>
                                    <Group.Control {...bfForm.appDtlAplc.schema.ptyCd} />
                                    <Group.Control {...bfForm.appDtlAplc.schema.ptyCntyNm} />
                                </Group.Row>

                                <Group.Row>
                                    <Group.Control {...bfForm.appDtlAplc.schema.ptyPostAddr} controlSize={10} />
                                </Group.Row>

                                <Group.Row>
                                    <Group.Control {...bfForm.appDtlAplc.schema.ptyPhysAddr} controlSize={10} />
                                </Group.Row>

                                <Group.Row>
                                    <Group.Control {...bfForm.appDtlAplc.schema.ptyCnttOfcrNm} />
                                    <Group.Control {...bfForm.appDtlAplc.schema.ptyCnttOfcrTelno} />
                                </Group.Row>

                                <Group.Row>
                                    <Group.Control {...bfForm.appDtlAplc.schema.ptyCnttOfcrEml} controlSize={10} />
                                </Group.Row>
                            </Group.Section>
                        </Layout>
                        {/* Hide exporter when policy flag = N (before modification) !== 표시정책이 N이면 수출자 숨김(수정전) ==! */}
                        {exppnVisible && props.state?.exppnDispYn !== "N" && (
                            <Layout direction="col">
                                <Layout>
                                    <Layout.Left>
                                        <Group.Title title={"T_EXPPN"} titleSize={1}></Group.Title>
                                    </Layout.Left>
                                </Layout>

                                <Group.Section>
                                    <Group.Row>
                                        <Group.Control {...bfForm.appDtlExppn.schema.ptyCd} />
                                        <Group.Control {...bfForm.appDtlExppn.schema.ptyCntyNm} />
                                    </Group.Row>

                                    <Group.Row>
                                        <Group.Control {...bfForm.appDtlExppn.schema.ptyPostAddr} controlSize={10} />
                                    </Group.Row>

                                    <Group.Row>
                                        <Group.Control {...bfForm.appDtlExppn.schema.ptyPhysAddr} controlSize={10} />
                                    </Group.Row>

                                    <Group.Row>
                                        <Group.Control {...bfForm.appDtlExppn.schema.ptyTelno} />
                                        <Group.Control {...bfForm.appDtlExppn.schema.ptyFaxNo} />
                                    </Group.Row>

                                    <Group.Row>
                                        <Group.Control {...bfForm.appDtlExppn.schema.ptyEml} controlSize={10} />
                                    </Group.Row>

                                    <Group.Row>
                                        <Group.Control {...bfForm.appDtlExppn.schema.wrhsNm} controlSize={10} />
                                    </Group.Row>
                                </Group.Section>
                            </Layout>
                        )}

                        {visible && (
                            <Layout direction="col">
                                <Layout>
                                    <Layout.Left>
                                        <Group.Title title={"T_CONSR"} titleSize={1}></Group.Title>
                                    </Layout.Left>
                                </Layout>

                                <Group.Section>
                                    <Group.Row>
                                        <Group.Control {...form.appDtlConsr.schema.ptyCd} />
                                        <Group.Control {...form.appDtlConsr.schema.ptyCntyNm} />
                                    </Group.Row>

                                    <Group.Row>
                                        <Group.Control {...form.appDtlConsr.schema.ptyPostAddr} controlSize={10} />
                                    </Group.Row>

                                    <Group.Row>
                                        <Group.Control {...form.appDtlConsr.schema.ptyPhysAddr} controlSize={10} />
                                    </Group.Row>

                                    <Group.Row>
                                        <Group.Control {...form.appDtlConsr.schema.ptyTelno} />
                                        <Group.Control {...form.appDtlConsr.schema.ptyFaxNo} />
                                    </Group.Row>

                                    <Group.Row>
                                        <Group.Control {...form.appDtlConsr.schema.ptyEml} controlSize={10} />
                                    </Group.Row>

                                    <Group.Row>
                                        <Group.Control {...form.appDtlConsr.schema.wrhsNm} controlSize={10} />
                                    </Group.Row>
                                </Group.Section>
                            </Layout>
                        )}

                        {/* Hide importer when policy flag = N (before modification) !== 표시정책이 N이면 수입자 숨김(수정전) ==! */}
                        {imppnVisible && props.state?.imppnDispYn !== "N" && (
                            <Layout direction="col">
                                <Layout>
                                    <Layout.Left>
                                        <Group.Title title={"T_IMPPN"} titleSize={1}></Group.Title>
                                    </Layout.Left>
                                </Layout>

                                <Group.Section>
                                    <Group.Row>
                                        <Group.Control {...bfForm.appDtlImppn.schema.ptyCd} />
                                        <Group.Control {...bfForm.appDtlImppn.schema.ptyCntyNm} />
                                    </Group.Row>

                                    <Group.Row>
                                        <Group.Control {...bfForm.appDtlImppn.schema.ptyPostAddr} controlSize={10} />
                                    </Group.Row>

                                    <Group.Row>
                                        <Group.Control {...bfForm.appDtlImppn.schema.ptyPhysAddr} controlSize={10} />
                                    </Group.Row>

                                    <Group.Row>
                                        <Group.Control {...bfForm.appDtlImppn.schema.ptyTelno} />
                                        <Group.Control {...bfForm.appDtlImppn.schema.ptyFaxNo} />
                                    </Group.Row>

                                    <Group.Row>
                                        <Group.Control {...bfForm.appDtlImppn.schema.ptyEml} controlSize={10} />
                                    </Group.Row>

                                    <Group.Row>
                                        <Group.Control {...bfForm.appDtlImppn.schema.wrhsNm} controlSize={10} />
                                    </Group.Row>
                                </Group.Section>
                            </Layout>
                        )}

                        {visible && (
                            <Layout direction="col">
                                <Layout>
                                    <Layout.Left>
                                        <Group.Title title={"T_CNSI"} titleSize={1}></Group.Title>
                                    </Layout.Left>
                                </Layout>

                                <Group.Section>
                                    <Group.Row>
                                        <Group.Control {...form.appDtlCnsl.schema.ptyCd} />
                                        <Group.Control {...form.appDtlCnsl.schema.ptyCntyNm} />
                                    </Group.Row>

                                    <Group.Row>
                                        <Group.Control {...form.appDtlCnsl.schema.ptyPostAddr} controlSize={10} />
                                    </Group.Row>

                                    <Group.Row>
                                        <Group.Control {...form.appDtlCnsl.schema.ptyPhysAddr} controlSize={10} />
                                    </Group.Row>

                                    <Group.Row>
                                        <Group.Control {...form.appDtlCnsl.schema.ptyTelno} />
                                        <Group.Control {...form.appDtlCnsl.schema.ptyFaxNo} />
                                    </Group.Row>

                                    <Group.Row>
                                        <Group.Control {...form.appDtlCnsl.schema.ptyEml} controlSize={10} />
                                    </Group.Row>

                                    <Group.Row>
                                        <Group.Control {...form.appDtlCnsl.schema.wrhsNm} controlSize={10} />
                                    </Group.Row>
                                </Group.Section>
                            </Layout>
                        )}
                        {/* ADD ITEM DETAIL */}
                        <APP_DTL_ADD_ITM param={bfAppInfo} form={bfForm} area={"GEN"} />
                        <APP_AMD_RGST_OFCR_ADD_ITM displayMode="before" param={bfAppInfo} form={bfForm} area={"GEN"} />
                    </Group.Body>
                </Group>
                {/* General Info Before Modification End */}
                {/* General Info After Modification Start */}
                <Group>
                    <Group.Body>
                        <Layout direction="col">
                            <Layout>
                                <Layout.Left>
                                    <Group.Title title={"T_APLC"} titleSize={1}></Group.Title>
                                </Layout.Left>
                            </Layout>

                            <Group.Section>
                                <Group.Row>
                                    <Group.Control {...form.appDtlAplc.schema.ptyCd} />
                                    <Group.Control {...form.appDtlAplc.schema.ptyCntyNm} />
                                </Group.Row>

                                <Group.Row>
                                    <Group.Control {...form.appDtlAplc.schema.ptyPostAddr} controlSize={10} />
                                </Group.Row>

                                <Group.Row>
                                    <Group.Control {...form.appDtlAplc.schema.ptyPhysAddr} controlSize={10} />
                                </Group.Row>

                                <Group.Row>
                                    <Group.Control {...form.appDtlAplc.schema.ptyCnttOfcrNm} />
                                    <Group.Control {...form.appDtlAplc.schema.ptyCnttOfcrTelno} />
                                </Group.Row>

                                <Group.Row>
                                    <Group.Control {...form.appDtlAplc.schema.ptyCnttOfcrEml} controlSize={10} />
                                </Group.Row>
                            </Group.Section>
                        </Layout>
                        {/* Hide exporter when policy flag = N (after modification) !== 표시정책이 N이면 수출자 숨김(수정후) ==! */}
                        {exppnVisible && props.state?.exppnDispYn !== "N" && (
                            <Layout direction="col">
                                <Layout>
                                    <Layout.Left>
                                        <Group.Title title={"T_EXPPN"} titleSize={1}></Group.Title>
                                    </Layout.Left>
                                </Layout>

                                <Group.Section>
                                    <Group.Row>
                                        <Group.Control {...form.appDtlExppn.schema.ptyCd} />
                                        <Group.Control {...form.appDtlExppn.schema.ptyCntyNm} />
                                    </Group.Row>

                                    <Group.Row>
                                        <Group.Control {...form.appDtlExppn.schema.ptyPostAddr} controlSize={10} />
                                    </Group.Row>

                                    <Group.Row>
                                        <Group.Control {...form.appDtlExppn.schema.ptyPhysAddr} controlSize={10} />
                                    </Group.Row>

                                    <Group.Row>
                                        <Group.Control {...form.appDtlExppn.schema.ptyTelno} />
                                        <Group.Control {...form.appDtlExppn.schema.ptyFaxNo} />
                                    </Group.Row>

                                    <Group.Row>
                                        <Group.Control {...form.appDtlExppn.schema.ptyEml} controlSize={10} />
                                    </Group.Row>

                                    <Group.Row>
                                        <Group.Control {...form.appDtlExppn.schema.wrhsNm} controlSize={10} />
                                    </Group.Row>
                                </Group.Section>
                            </Layout>
                        )}

                        {visible && (
                            <Layout direction="col">
                                <Layout>
                                    <Layout.Left>
                                        <Group.Title title={"T_CONSR"} titleSize={1}></Group.Title>
                                    </Layout.Left>
                                </Layout>

                                <Group.Section>
                                    <Group.Row>
                                        <Group.Control {...form.appDtlConsr.schema.ptyCd} />
                                        <Group.Control {...form.appDtlConsr.schema.ptyCntyNm} />
                                    </Group.Row>

                                    <Group.Row>
                                        <Group.Control {...form.appDtlConsr.schema.ptyPostAddr} controlSize={10} />
                                    </Group.Row>

                                    <Group.Row>
                                        <Group.Control {...form.appDtlConsr.schema.ptyPhysAddr} controlSize={10} />
                                    </Group.Row>

                                    <Group.Row>
                                        <Group.Control {...form.appDtlConsr.schema.ptyTelno} />
                                        <Group.Control {...form.appDtlConsr.schema.ptyFaxNo} />
                                    </Group.Row>

                                    <Group.Row>
                                        <Group.Control {...form.appDtlConsr.schema.ptyEml} controlSize={10} />
                                    </Group.Row>

                                    <Group.Row>
                                        <Group.Control {...form.appDtlConsr.schema.wrhsNm} controlSize={10} />
                                    </Group.Row>
                                </Group.Section>
                            </Layout>
                        )}

                        {/* Hide importer when policy flag = N (after modification) !== 표시정책이 N이면 수입자 숨김(수정후) ==! */}
                        {imppnVisible && props.state?.imppnDispYn !== "N" && (
                            <Layout direction="col">
                                <Layout>
                                    <Layout.Left>
                                        <Group.Title title={"T_IMPPN"} titleSize={1}></Group.Title>
                                    </Layout.Left>
                                </Layout>

                                <Group.Section>
                                    <Group.Row>
                                        <Group.Control {...form.appDtlImppn.schema.ptyCd} />
                                        <Group.Control {...form.appDtlImppn.schema.ptyCntyNm} />
                                    </Group.Row>

                                    <Group.Row>
                                        <Group.Control {...form.appDtlImppn.schema.ptyPostAddr} controlSize={10} />
                                    </Group.Row>

                                    <Group.Row>
                                        <Group.Control {...form.appDtlImppn.schema.ptyPhysAddr} controlSize={10} />
                                    </Group.Row>

                                    <Group.Row>
                                        <Group.Control {...form.appDtlImppn.schema.ptyTelno} />
                                        <Group.Control {...form.appDtlImppn.schema.ptyFaxNo} />
                                    </Group.Row>

                                    <Group.Row>
                                        <Group.Control {...form.appDtlImppn.schema.ptyEml} controlSize={10} />
                                    </Group.Row>

                                    <Group.Row>
                                        <Group.Control {...form.appDtlImppn.schema.wrhsNm} controlSize={10} />
                                    </Group.Row>
                                </Group.Section>
                            </Layout>
                        )}

                        {visible && (
                            <Layout direction="col">
                                <Layout>
                                    <Layout.Left>
                                        <Group.Title title={"T_CNSI"} titleSize={1}></Group.Title>
                                    </Layout.Left>
                                </Layout>

                                <Group.Section>
                                    <Group.Row>
                                        <Group.Control {...form.appDtlCnsl.schema.ptyCd} />
                                        <Group.Control {...form.appDtlCnsl.schema.ptyCntyNm} />
                                    </Group.Row>

                                    <Group.Row>
                                        <Group.Control {...form.appDtlCnsl.schema.ptyPostAddr} controlSize={10} />
                                    </Group.Row>

                                    <Group.Row>
                                        <Group.Control {...form.appDtlCnsl.schema.ptyPhysAddr} controlSize={10} />
                                    </Group.Row>

                                    <Group.Row>
                                        <Group.Control {...form.appDtlCnsl.schema.ptyTelno} />
                                        <Group.Control {...form.appDtlCnsl.schema.ptyFaxNo} />
                                    </Group.Row>

                                    <Group.Row>
                                        <Group.Control {...form.appDtlCnsl.schema.ptyEml} controlSize={10} />
                                    </Group.Row>

                                    <Group.Row>
                                        <Group.Control {...form.appDtlCnsl.schema.wrhsNm} controlSize={10} />
                                    </Group.Row>
                                </Group.Section>
                            </Layout>
                        )}
                        {/* ADD ITEM DETAIL */}
                        <APP_AMD_DTL_ADD_ITM bfParam={bfAppInfo} param={props.state} form={form} area={"GEN"} />
                        <APP_AMD_RGST_OFCR_ADD_ITM bfParam={bfAppInfo} 
                        bfOfcrAddItmForm={bfForm.appRgstOfcrAddItm} 
                        param={props.state} 
                        form={form} 
                        area={"GEN"} 
                        ofcrAddItmEditable={props.ofcrAddItmEditable}
                        onOfcrAddItmChange={props.onOfcrAddItmChange} 
                        onRegisterTabSave={props.onRegisterTabSave} 
                        onRegisterTabValid={props.onRegisterTabValid} />
    
                    </Group.Body>
                </Group>
                {/* General Info After Modification End */}
            </Layout>
        </>
    );
};
